import gql from 'graphql-tag'
import { responsiveMediaFragment, type ResponsiveMedia } from './mediaFragments.gql'

export const getInstagramPostsQuery = gql`query GetInstagramPosts(
  $limit: IntType!,
  $offset: IntType!,
  $baseProducts: [ItemId!]
) {
  allInstagramPosts(
    first: $limit
    skip: $offset
    orderBy: timestamp_DESC
    filter: {baseProduct: {in: $baseProducts}}
  ) {
    id
    caption
    likes
    timestamp
    baseProduct {
      id
      sku
      url
    }
    customProductParts {
      id
      sku
    }
    ${responsiveMediaFragment('thumbnail', '{ w: "400", h: "400", fit: crop }')}
  }
}`

export type InstagramPost = {
  id: string
  caption: string
  baseProduct: {
    id: string
    sku: string
    url: string
  }
  customProductParts: {
    id: string
    sku: string
  }[]
  thumbnail: ResponsiveMedia
  sku?: string
  productTitle?: string
  url?: string
}

export type GetInstagramPostsResponse = {
  allInstagramPosts: InstagramPost[]
}